const CONTENT_PLACEMENT_ANIMATIONS = {
  NO_EFFECT: 'NO_EFFECT',
  SLIDE: 'SLIDE',
};

export default CONTENT_PLACEMENT_ANIMATIONS;
